import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import LinkProvider from '../../../../CommonComponents/LinkProvider/LinkProvider';
import { formatDate, removeDomainName, deleteExchangeStorageData } from '../../../../utils/helper';
import Menu from '../../../../CommonComponents/Menu/Menu';
import MenuItem from '../../../../CommonComponents/MenuItem/MenuItem';
import { connect } from 'react-redux';
import Button from '../../../../CommonComponents/BootstrapComponents/Button/Button';
// import ArrowDropDown from '../../../../../static/assets/svg/mui-icons/ArrowDropDown.svg';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
import * as cartCallsActionCreators from '../../../../actionCreators/cart';
import getSetCookie from '../../../../cookie';

function honorFlags(returnable, isExchangeable, isRefundable, alreadyReturned = false, exchangeOnlyCta) {
  let dataPrefix = 'data';
  let returnStateKey = '';
  if (alreadyReturned) {
    dataPrefix = 'data_returned';
  }
  if (returnable && isExchangeable && isRefundable) {
    returnStateKey = `${dataPrefix}_refundable_exchangeable`;
  } else if (returnable && isExchangeable && !isRefundable) {
    returnStateKey = `${dataPrefix}_nonrefundable_exchangeable`;
  } else if (returnable && !isExchangeable && isRefundable) {
    returnStateKey = `${dataPrefix}_refundable_nonexchangeable`;
  } else if (!returnable || (!isExchangeable && !isRefundable && !alreadyReturned)) {
    returnStateKey = `${dataPrefix}_nonrefundable_nonexchangeable`;
  }
  if (!returnable && exchangeOnlyCta) {
    returnStateKey = `${dataPrefix}_nonrefundable_exchangeable`;
  }
  return returnStateKey;
}

const exchangeOnlyStates = [
  'data_returned_nonrefundable_exchangeable',
  'data_nonrefundable_exchangeable',
];

function ItemFooter(props) {
  const {
    cartCallsAction,
    returnConfig,
    history,
    returnReasonsArr,
    dataLocale,
    returnSelection: { viewPolicyLink, viewPolicyText, itemReturnState },
    returnId,
    classification,
    returnEligibilityItemDetails,
    isReturnCancelled,
    orderId,
    itemId,
    cartData,
  } = props; // dataLocale, setReturnItemDetails, setNewExchangeFLow, deliveryDate
  const { returnExchange, returnDetails } = returnConfig;
  const { returnable, isExchangeable, isRefundable, refundMethodRequest, returnEligibleTillDate, exchangeOnlyCta } =
    returnEligibilityItemDetails || {};
  const { SELECT_THE_PROBLEM_WITH_THE_PRODUCT } = dataLocale;
  const isValidReturnId = returnId && !isReturnCancelled;
  const todayDateTs = new Date().getTime();
  let returnAllowedDate = '';
  let returnAllowedDateTs;
  let returnState = null;
  if (!isValidReturnId && returnEligibleTillDate) {
    returnAllowedDateTs = new Date(returnEligibleTillDate).getTime();
    returnAllowedDate = formatDate(returnAllowedDateTs, 'D MMM', 'year');
  }
  let returnStateKey;
  if (
    returnDetails === 'ON' &&
    isValidReturnId &&
    (!refundMethodRequest || refundMethodRequest === 'exchange')
  ) {
    returnStateKey = honorFlags(true, isExchangeable, isRefundable, true, exchangeOnlyCta);
    if (returnStateKey) {
      returnState = itemReturnState[returnStateKey];
    }
  } else if (returnExchange === 'ON' && returnAllowedDateTs && returnAllowedDateTs > todayDateTs) {
    returnStateKey = honorFlags(returnable, isExchangeable, isRefundable, false, exchangeOnlyCta);
    if (returnStateKey) {
      returnState = itemReturnState[returnStateKey];
    }
  } else if (returnExchange === 'ON' && returnAllowedDateTs && returnAllowedDateTs < todayDateTs) {
    returnState = itemReturnState.data_nonrefundable_nonexchangeable;
    returnState.innerBoxTitle = '' + returnState.innerBoxTitleDateExpired;
    returnState.innerBoxSubText = '';
  }
  const [anchorEl, setAnchorEl] = useState(null);
  const [exchangeButtonClicked, setExchangeButtonClicked] = useState({
    isButtonClicked: false,
    data: {},
  });
  const handleClick = event => {
    getSetCookie.setCookie('isReturnExOld', true, 0.5);
    // console.log('isReturnExOld cookie set');
    setAnchorEl(event.target);
  };
  const handleClose = () => {
    getSetCookie.deleteCookie('isReturnExOld');
    // console.log('isReturnExOld cookie delete');
    setAnchorEl(null);
  };
  const handleReason = (event, orderId, history, itemId) => {
    getSetCookie.setCookie('isReturnExOld', true, 0.5);
    // console.log('isReturnExOld cookie set');
    // Delete items from cart to enter in exchange flow
    if (cartData && cartData.items && cartData.items) {
      for (let i = 0; i < cartData.items.length; i++) {
        cartCallsAction.updateCartItem(cartData.items[i].id);
      }
    }
    // cartData && cartData.items && cartData.items.map(item => {
    //     cartCallsAction.updateCartItem(item.id);
    // });
    deleteExchangeStorageData();
    // replaced event.currentTarget.dataset.myValue => event.target.value (LKUI-6228)
    setExchangeButtonClicked({
      isButtonClicked: true,
      data: { primaryReason: event.target.value, orderId, history, itemId },
    });
  };
  const { title, subText, innerBoxTitle, innerBoxSubText, returnCTA } = returnState || {};

  useEffect(() => {
    if (cartData && cartData.itemsCount === 0 && exchangeButtonClicked.isButtonClicked) {
      const { primaryReason, orderId, history, itemId } = exchangeButtonClicked.data;
      let exchangeOrderId = sessionStorageHelper.getItem('exchangeOrderId') || {};
      exchangeOrderId = orderId;
      sessionStorageHelper.setItem('exchangeOrderId', exchangeOrderId);
      if (exchangeOnlyStates.includes(returnStateKey)) {
        // ExchangeOnly case
        sessionStorageHelper.setItem('isExchangeOnlyCase', true);
      } else {
        setAnchorEl(null);
        sessionStorageHelper.setItem('primaryReason', primaryReason);
      }
      history.push({
        pathname: `/customer/my/order/return/${orderId}/${itemId}`,
        state: { orderId, itemId, primaryReason },
      });
    }
  }, [cartData, exchangeButtonClicked]);

  // if (orderData && orderData.items && !itemReturnId) {
  //     const currentItem = orderData.items.find(item => item.id === itemId);
  //     if (currentItem && currentItem.returnId) {
  //     const { itemTracking, returnId: itemReturnId } = currentItem;
  //     returnItemId = itemReturnId && itemTracking?.status === 'RETURN_REQUESTED' ? itemReturnId : null;
  //     if (returnItemId) setItemReturnId(returnItemId);
  //     }
  // }

  return returnState ? (
    <div className="popin-content flex-row-reverse display-flex mr-t20 margin-r15 margin-l15 margin-b10">
      <div className="pd-15">
        {title && (
          <div className="order-item-footer align-items-center text-right ">
            {(!refundMethodRequest && !returnId) || isReturnCancelled ? (
              <>
                <Button
                  className="btn margin-b5 bg-color-white fs14 bora-4 padding-12 lh-16 text-uppercase text-color_link_blue btn-focus "
                  style={{ border: '1px solid #00bac6', color: '#00bac6' }}
                  onClick={event => handleClick(event)}
                >
                  {returnCTA}
                  <img
                    alt="arrow-down"
                    className="margin-l5"
                    src="https://static.lenskart.com/media/desktop/img/myorder/ArrowDropDown.svg"
                  />
                </Button>
                <Menu
                  keepMounted
                  anchorEl={anchorEl}
                  id="simple-menu"
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem
                    disabled
                    menuItemStyles={{
                      width: '250px',
                      height: '30px',
                      fontSize: '14px',
                      marginTop: '3px',
                    }}
                  >
                    {SELECT_THE_PROBLEM_WITH_THE_PRODUCT}
                  </MenuItem>
                  {returnReasonsArr &&
                    returnReasonsArr[classification] &&
                    returnReasonsArr[classification].map(returnReason => (
                      <MenuItem
                        key={returnReason.id}
                        data-my-value={returnReason.reason}
                        menuItemStyles={{
                          width: '250px',
                          height: '30px',
                          fontSize: '14px',
                          marginTop: '3px',
                        }}
                        value={returnReason.reason}
                        onChange={event => handleReason(event, orderId, history, itemId)}
                      >
                        {returnReason.reason}
                      </MenuItem>
                    ))}
                </Menu>
              </>
            ) : (
              <Button
                className="btn margin-b5 bg-color-white fs14 bora-4 padding-12 lh-16 text-uppercase text-color_link_blue btn-focus "
                style={{ border: '1px solid #00bac6', color: '#00bac6' }}
                onClick={event => handleReason(event, orderId, history, itemId)}
              >
                {returnCTA}
              </Button>
            )}
            <div className="mr-r20 text-right flex-1 margin-t4">
              <div className="fs12 block text-color_pale_black text-color-grey">{title}</div>
              {returnAllowedDate && (
                <span className="mr-t5 fw500 block">
                  {subText.replace('%date', returnAllowedDate)}
                </span>
              )}
            </div>
          </div>
        )}
        {innerBoxTitle && (
          <div className="mr-t10 pd-10 bora-4 align-items-center">
            <div className="mr-r20 flex-1 text-right margin-b2">
              {returnAllowedDate && (
                <div className="fw500 block text-color_pale_black text-color-grey">
                  {innerBoxTitle.replace('%date', returnAllowedDate)}
                </div>
              )}
              {innerBoxSubText && (
                <div className="mr-t5 block text-color_pale_black text-color-grey">
                  {innerBoxSubText}
                </div>
              )}
            </div>
            <div className="text-right margin-t2">
              <LinkProvider
                className="text-color_link_blue fw700 text-uppercase"
                to={removeDomainName(viewPolicyLink)}
              >
                {viewPolicyText}
              </LinkProvider>
            </div>
          </div>
        )}
      </div>
    </div>
  ) : null;
}

const mapStateToProps = state => {
  const cartData = state.cart.cartData ? state.cart.cartData.result : null;
  return {
    returnReasonsArr: state.returnExchange.returnReasonsArr,
    cartData,
    dataLocale: state.locale,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    // getReturnReasons: classification => dispatch(getReturnReasons(classification))
    cartCallsAction: bindActionCreators(cartCallsActionCreators, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ItemFooter);
